@if (isMenuLoaded) {
  <div
    [ngClass]="{'is-menu-reduced': menuState.isReduced, 'is-menu-mobile-opened': menuState.isMenuMobileOpened}"
    class="menu_left">
    <div class="menu_left-logo" (click)="navigateToAccueil()">
      @if (menuState.isReduced) {
        <img alt=""
          src="../../../../assets/images/logo/picto-small.svg">
        } @else {
          <img alt="" src="../../../../assets/images/logo/logo-small.svg">
        }
      </div>
      <div class="menu-content">
        <div class="menu_content-list">
          <app-entites-dropdownlist class="is-mobile"></app-entites-dropdownlist>
          <ul class="menu-list">
            @for (menuItem of menuLeft; track menuItem) {
              <li>
                <app-menu-item [menuItem]="menuItem" [menuState]="menuState" (requestActivation)="onMenuClicked(menuItem)" [selected]="isSelected(menuItem)"></app-menu-item>
              </li>
            }
            @for (menuItem of menuTop; track menuItem) {
              <li class="menu_left_is-mobile">
                <app-menu-item [menuItem]="menuItem" [menuState]="menuState"></app-menu-item>
              </li>
            }
          </ul>
        </div>
      </div>
      <div class="market-container" (click)="navigateToMarketPlace()" [ngClass]="{'is-menu-reduced': menuState.isReduced}">
        <div class="market">
          <div class="icon">
            <i class="icon icon-market"></i>
          </div>
          <div class="libele" [ngClass]="{'is-menu-reduced': menuState.isReduced}">
            <p>E-store</p>
          </div>
        </div>
      </div>
      <div class="version" [ngClass]="{'is-menu-reduced': menuState.isReduced}">
        <p>Version: {{version}}</p>
      </div>
    </div>
  }

  @if (menuState.isMenuMobileOpened) {
    <div class="menu_left_mobile-background" (click)="closeMenuMobile()" [@fadeInOut]></div>
  }
